import React from 'react'

const Profile = () => {
  return (
    <div>Profile Page</div>
  )
}

export default Profile;